import React from 'react'

import s from './index.module.sass'

export const NoVideo = () => {
  return (
    <div className={s.text}>No videos found</div>
  )
}
